import { notify } from '@/app/plugins/notification'
import { AxiosError } from 'axios'

export function useAsyncStateErrorHandler(ex: unknown) {
  const error = ex as AxiosError
  if (!error.isAxiosError) notify({ title: 'Ошибка', message: error.message || 'Неожиданная ошибка', color: '#FF5252' })
  else notify({ title: 'Ошибка', message: error.response?.status !== 500 ? error.response?.data.detail || 'Неожиданная ошибка' : 'Неожиданная ошибка', color: '#FF5252' })
  // if (!error.isAxiosError) notificationCall(error.message || 'Неожиданная ошибка')
  // else notificationCall(error.response?.status !== 500 ? error.response?.data.detail || 'Неожиданная ошибка' : 'Неожиданная ошибка')
  throw ex
}
